import { Link, Typography } from '@mui/material'
import React from 'react'

import Button from 'components/common/Button'
import theme from 'theme'

export const CompanyNameAlternatives: React.FC<{
  alternateNames: string[]
  handleClearConflict: () => void
  handleCompanyNameChange: (name: string) => void
}> = ({ alternateNames, handleClearConflict, handleCompanyNameChange }) => (
  <>
    <ul
      css={{
        listStyle: 'none',
        padding: theme.space[3]
      }}
    >
      {alternateNames.map((name) => (
        <li key={name}>
          <Link
            data-test-company-name-alternatives-name
            component="button"
            onClick={(event) => {
              event.preventDefault()
              handleCompanyNameChange(name)
            }}
          >
            {name}
          </Link>
        </li>
      ))}
    </ul>

    <Typography css={{ paddingBottom: theme.space[2] }}>or</Typography>
    <Button
      data-test-company-name-alternatives-pick-a-new-name
      onClick={handleClearConflict}
    >
      Pick a new name
    </Button>
  </>
)
